import { render, staticRenderFns } from "./nemipayForm.vue?vue&type=template&id=8595ee74&"
import script from "./nemipayForm.vue?vue&type=script&lang=ts&"
export * from "./nemipayForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports